import './Cart.scss';

import React from 'react';
import PropTypes from 'prop-types';

import Rails from '@rails/ujs';

import RecommendedCartItem from './RecommendedCartItem';
import ClearCart from '../ui/elements/buttons/Delete';
import CreateOrderForm from './CreateOrderForm';
import Currency from '../ui/elements/Currency';
import Icon from '../ui/elements/Icon';
import Loader from '../ui/elements/Loader';
import PageTitle from '../ui/layout/PageTitle';

const SORT_BY_ALPHABET = 'SORT_BY_ALPHABET';
const SORT_BY_CREATED_AT = 'SORT_BY_CREATED_AT';

class RecommendedCart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      recommendedCartItems: this.props.recommendedCartItems || [],
      discardedRecommendedCartItems: this.props.discardedRecommendedCartItems || [],
      isLoading: false,
      activeRebate: this.props.activeRebate,
      sorting: this.props.sorting,
      allSelected: this.props.allSelected
    };

    this.handleClear = this.handleClear.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleChangeCartItem = this.handleChangeCartItem.bind(this);
    this.handleChangeSelected = this.handleChangeSelected.bind(this);
    this.handleSortingChange = this.handleSortingChange.bind(this);
    this.handleChangeAllSelected = this.handleChangeAllSelected.bind(this);
    this.handleRebate = this.handleRebate.bind(this);
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    fetch('/recommended_cart_items.json', { credentials: 'same-origin' })
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          return response.json();
        } else {
          const error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then((response) => {
        const rebate = response['cart_items'].filter((cartItem) => cartItem.rebateClause)[0];
        this.setState({
          recommendedCartItems: response['cart_items'].map((cartItem) => ({ ...cartItem, selected: true })),
          discardedRecommendedCartItems: response['discarded_recommended_cart_items'].map((cartItem) => ({ ...cartItem, selected: null })),
          // activeRebate: rebate,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        alert('Возникла ошибка при попытке загрузить информацию о деталях в корзине');
      });
  }

  handleClear() {
    if (this.props.needConfirm && (!this.props.needConfirm || !confirm("Вы уверены, что хотите очистить обязательную корзину?"))) {
      return false;
    }

    this.setState({ isLoading: true });
    fetch('/recommended_cart_items/clear', {
      credentials: 'same-origin',
      headers: { 'X-CSRF-Token': Rails.csrfToken() },
      method: 'DELETE',
    })
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(() => {
        this.setState({ recommendedCartItems: [], isLoading: false });
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        alert('При попытке очистить корзину возникла ошибка.');
      });
  }

  handleDelete(id) {
    this.setState((state) => ({
      recommendedCartItems: state.recommendedCartItems.filter((recommendedCartItem) => recommendedCartItem.id !== id),
      discardedRecommendedCartItems: state.discardedRecommendedCartItems.filter((cartItem) => cartItem.id !== id),
    }));
  }

  handleChangeCartItem(id, data) {
    this.setState((state) => ({
      recommendedCartItems: state.recommendedCartItems.map((recommendedCartItem) => {
        if (recommendedCartItem.id === id) {
          return {
            ...recommendedCartItem,
            airdelivery: data.airDelivery,
            quantity: data.quantity,
            price: data.price,
            sum: data.sum,
          };
        } else {
          return recommendedCartItem;
        }
      }),
    }));
  }

  handleChangeAllSelected(event) {
    this.setState({
      allSelected: event.target.checked,
      recommendedCartItems: this.state.recommendedCartItems.map((cartItem) => ({ ...cartItem, selected: event.target.checked })),
    });
  }

  handleChangeSelected(id, selected) {
    this.setState((state) => ({
      recommendedCartItems: state.recommendedCartItems.map((recommendedCartItem) => {
        if (recommendedCartItem.id === id) {
          return { ...recommendedCartItem, selected: selected };
        } else {
          return recommendedCartItem;
        }
      }),
    }));

    if (this.props.onChangeSelected) {
      this.props.onChangeSelected(id, selected);
    }
  }

  handleSortingChange(newSorting) {
    this.setState({ sorting: newSorting });

    const data = new FormData();
    data.append('user[cart_items_sort_type]', newSorting.toLowerCase());
    fetch(`/settings.json`, {
      body: data,
      credentials: 'same-origin',
      headers: { 'X-CSRF-Token': Rails.csrfToken() },
      method: 'PATCH',
    })
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .catch((error) => {
        alert('Произошла ошибка при попытке сохранить в настройках сортировку по-умолчанию');
      });
  }

  handleRebate(clause) {
    const data = new FormData();
    if (clause) {
      this.setState({ isLoading: true });
      data.append('rebate_clause_id', clause.id);
      fetch(`/recommended_cart_items/rebate_clause_agree.json`, {
        body: data,
        credentials: 'same-origin',
        headers: { 'X-CSRF-Token': Rails.csrfToken() },
        method: 'POST',
      })
        .then(function (response) {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
          }
        })
        .then((response) => {
          if (response["notice"]) {
            alert(response["notice"]);
          } else {
            this.state.activeRebate = clause;
            this.componentDidMount();
          }
          this.setState({ isLoading: false });
        })
        .catch((error) => {
          alert('Произошла ошибка');
        });
    }
  }

  get hasBrandsWithAirDelivery() {
    return this.state.recommendedCartItems.filter((recommendedCartItem) => recommendedCartItem.part.brand.airDelivery).length > 0;
  }

  get hasFragileParts() {
    return this.selectedCartItems.filter((cartItem) => cartItem.part.fragile).length > 0;
  }

  get hasUnavailableFordParts() {
    return this.selectedCartItems.filter((cartItem) => cartItem.part.fordAndUnavailable).length > 0;
  }

  get selectedCartItems() {
    return this.state.recommendedCartItems.filter((recommendedCartItem) => recommendedCartItem.selected);
  }

  suitableFor(clause) {
    return this.rebateSum(clause) >= clause.minimalSum;
  }

  rebateSum(clause) {
    return this.selectedCartItems.reduce((accumulator, recommendedCartItem) => {
      if ((clause.brandIds.length == 0 || clause.brandIds.includes(recommendedCartItem.part.brandId)) && (recommendedCartItem.rebatable)) {
        return accumulator + recommendedCartItem.sum;
      } else {
        return accumulator;
      }
    }, 0);
  }

  pluralize(count, variants) {
    let variant = '';

    if ([5, 6, 7, 8, 9, 0].includes(count % 10) || (count >= 11 && count <= 14)) {
      variant = variants[2];
    } else if ([2, 3, 4].includes(count % 10)) {
      variant = variants[1];
    } else {
      variant = variants[0];
    }

    return count + ' ' + variant;
  }

  sortingFunction(sortingType) {
    switch (sortingType) {
      case SORT_BY_ALPHABET:
        return function (cartItem1, cartItem2) {
          const a = [cartItem1.part.brand.name, cartItem1.part.article, cartItem1.part.description].join('');
          const b = [cartItem2.part.brand.name, cartItem2.part.article, cartItem2.part.description].join('');
          if (a < b) {
            return -1;
          }
          if (a > b) {
            return 1;
          }
          return 0;
        };
      case SORT_BY_CREATED_AT:
        return function (cartItem1, cartItem2) {
          if (cartItem1.createdAt < cartItem2.createdAt) {
            return -1;
          }
          if (cartItem1.createdAt > cartItem2.createdAt) {
            return 1;
          }
          return 0;
        };
      default:
        throw new Error('Неизвестный способ сортировки деталей в корзине.');
    }
  }

  get sum() {
    return this.selectedCartItems.reduce((accumulator, cartItem) => {
      return accumulator + cartItem.sum;
    }, 0);
  }

  get weight() {
    return this.selectedCartItems.reduce((accumulator, cartItem) => {
      return accumulator + cartItem.quantity * cartItem.part.weight;
    }, 0);
  }

  render() {
    const users = this.state.recommendedCartItems.concat(this.state.discardedRecommendedCartItems).reduce((accumulator, cartItem) => {
      Object.defineProperty(accumulator, cartItem.user.id === window._current_user.id ? '' : cartItem.user.name, {
        value: cartItem.user.id,
      });
      return accumulator;
    }, {});
    const userNames = Object.getOwnPropertyNames(users).sort();

    // const recommendedCartItems = userNames.map((name) => {
    //   return (
    //     <React.Fragment key={users[name]}>
    //       {userNames.length > 1 && (
    //         <tr>
    //           <td colSpan={this.hasBrandsWithAirDelivery ? 13 : 12}>
    //             <h3 className="title is-size-6">{name === '' ? 'Моя корзина' : name}</h3>
    //           </td>
    //         </tr>
    //       )}
    //       {this.state.recommendedCartItems
    //           .filter((recommendedCartItem) => recommendedCartItem.user.id === users[name])
    //           .sort(this.sortingFunction(this.state.sorting))
    //           .map((recommendedCartItem, index) => (
    //             <RecommendedCartItem
    //               key={recommendedCartItem.id}
    //               airDelivery={recommendedCartItem.airDelivery}
    //               index={index}
    //               id={recommendedCartItem.id}
    //               limitQuantity={recommendedCartItem.limitQuantity}
    //               maximumQuantity={recommendedCartItem.maximumQuantity}
    //               minimumQuantity={recommendedCartItem.minimumQuantity}
    //               color={recommendedCartItem.color}
    //               textColor={recommendedCartItem.textColor}
    //               packingQuantity={recommendedCartItem.part.packingQuantity}
    //               packingUnit={recommendedCartItem.part.packingUnit}
    //               part={recommendedCartItem.part}
    //               price={recommendedCartItem.price}
    //               quantity={recommendedCartItem.quantity}
    //               selected={recommendedCartItem.selected}
    //               showAirDelivery={this.hasBrandsWithAirDelivery}
    //               soldInPacks={recommendedCartItem.soldInPacks}
    //               source={recommendedCartItem.source}
    //               sum={recommendedCartItem.sum}
    //               supplied={recommendedCartItem.part.supplied}
    //               onDelete={this.handleDelete}
    //               onChange={this.handleChangeCartItem}
    //               onChangeSelected={this.handleChangeSelected}
    //               quantityWasChanged={recommendedCartItem.quantityWasChanged}
    //             />
    //           ))}
    //     </React.Fragment>
    //   );
    // });

    const recommendedCartItems = this.state.recommendedCartItems.sort(this.sortingFunction(this.state.sorting))
      .map((recommendedCartItem, index) => (
        <RecommendedCartItem
          key={recommendedCartItem.id}
          airDelivery={recommendedCartItem.airDelivery}
          index={index}
          id={recommendedCartItem.id}
          limitQuantity={recommendedCartItem.limitQuantity}
          maximumQuantity={recommendedCartItem.maximumQuantity}
          minimumQuantity={recommendedCartItem.minimumQuantity}
          color={recommendedCartItem.color}
          textColor={recommendedCartItem.textColor}
          packingQuantity={recommendedCartItem.part.packingQuantity}
          packingUnit={recommendedCartItem.part.packingUnit}
          part={recommendedCartItem.part}
          price={recommendedCartItem.price}
          clearPrice={recommendedCartItem.clearPrice}
          quantity={recommendedCartItem.quantity}
          selected={recommendedCartItem.selected}
          showAirDelivery={this.hasBrandsWithAirDelivery}
          soldInPacks={recommendedCartItem.soldInPacks}
          rebateClauseId={recommendedCartItem.rebateClauseId}
          source={recommendedCartItem.source}
          sum={recommendedCartItem.sum}
          supplied={recommendedCartItem.part.supplied}
          onDelete={this.handleDelete}
          onChange={this.handleChangeCartItem}
          onChangeSelected={this.handleChangeSelected}
          quantityWasChanged={recommendedCartItem.quantityWasChanged}
          discarded={false}
          employee={this.props.employee}
          orderSum={this.sum}
          needConfirm={this.props.needConfirm}
        />
      ));

    const weight = this.weight > 0 && (
      <React.Fragment>
        <p className="is-size-7">примерный вес заказа</p>
        <p className="is-size-5">≈{this.weight.toLocaleString()} кг</p>
      </React.Fragment>
    );

    const partsWithChangedQuantity = this.state.recommendedCartItems.filter((item) => item.quantityWasChanged);

    const table = (
      <React.Fragment>
        {partsWithChangedQuantity.length > 0 &&
          <div className="notification is-info">
            Количество деталей {partsWithChangedQuantity.map((item) => item.part.article).join(', ')} увеличено до целой
            упаковки. Измененные позиции выделены цветом.
          </div>}
        <div className="select Cart-selectSorting">
          <select value={this.state.sorting} onChange={(event) => this.handleSortingChange(event.target.value)}>
            <option value={SORT_BY_ALPHABET}>Сортировать по бренду, артикулу, наименованию</option>
            <option value={SORT_BY_CREATED_AT}>Сортировать по времени добавления</option>
          </select>
        </div>
        <table className="table RecommendedCart is-bordered">
          <thead>
            <tr>
              <th className="has-text-centered is-vertically-middle" />
              <th className="has-text-centered is-vertically-middle">Бренд</th>
              <th className="has-text-centered is-vertically-middle">Артикул</th>
              <th className="has-text-centered is-vertically-middle">Наименование детали</th>
              <th className="has-text-centered is-vertically-middle">Цена</th>
              <th className="has-text-centered is-vertically-middle">Склад</th>
              <th className="has-text-centered is-vertically-middle">Наличие</th>
              <th className="has-text-centered is-vertically-middle">Статус</th>
              <th className="has-text-centered is-vertically-middle">Количество</th>
              {this.hasBrandsWithAirDelivery && (
                <th className="has-text-centered is-vertically-middle CartItem-th-with-icon" title="Укажите необходимость авиадоставки">
                  <Icon icon="plane-departure" size="medium" />
                </th>
              )}
              <th className="has-text-centered is-vertically-middle">Стоимость</th>
              <td />
              <td />
            </tr>
          </thead>
          <tbody>{recommendedCartItems}</tbody>
          {this.selectedCartItems.length > 0 && (
            <tfoot className="Cart-total">
              <tr>
                <td style={{ borderRight: 0 }} colSpan="3" />
                <td style={{ borderRight: 0, borderLeft: 0 }} colSpan="3">{weight}</td>
                <td style={{ borderRight: 0, borderLeft: 0 }}
                  className="has-text-right is-nowrapped is-size-2 Cart-total"
                  colSpan={this.hasBrandsWithAirDelivery ? 5 : 4}
                >
                  <Currency value={this.sum} />
                </td>
                <td style={{ borderRight: 0, borderLeft: 0 }}>
                  <ClearCart title="Очистить корзину" onDelete={this.handleClear} />
                </td>
                <td style={{ borderLeft: 0 }} />
              </tr>
            </tfoot>
          )}
        </table>
        {this.selectedCartItems.length > 0 && (
          <CreateOrderForm
            addresses={this.props.addresses}
            branches={this.props.branches}
            deliveryPreferences={this.props.deliveryPreferences}
            cartItems={this.selectedCartItems}
            deliveryWays={this.props.deliveryWays}
            paymentTypes={this.props.paymentTypes}
            dealers={this.props.dealers}
            fragile={this.hasFragileParts}
            dealerFord={this.props.dealerFord}
            warrantyEmployee={this.props.warrantyEmployee}
            selectedBranch={this.props.selectedBranch}
            selectedDeliveryWay={this.props.selectedDeliveryWay}
            employee={this.props.employee}
            canBuyForClient={this.props.canBuyForClient}
            companies={this.props.companies}
            canPayOnline={this.props.canPayOnline}
            canSendToBranch={false}
            hasUnavailableFordParts={this.hasUnavailableFordParts}
            onSubmit={this.handleSubmit}
            needCompensation={this.props.needCompensation}
            recommended={true}
          />
        )}
      </React.Fragment>
    );

    return (
      <React.Fragment>
        <React.Fragment>
          <PageTitle title="Обязательная корзина" />
          {this.state.isLoading && recommendedCartItems.length === 0 && <Loader text="Загрузка информации о товарах..." />}
          {this.state.isLoading && recommendedCartItems.length > 0 && <div className="Cart-loading">{table}</div>}
          {!this.state.isLoading && recommendedCartItems.length === 0 && <p>Ваша обязательная корзина пуста.</p>}
          {!this.state.isLoading && this.props.rebateClauses.length > 0 && (
            this.props.rebateClauses.filter((rebateClause) => this.suitableFor(rebateClause))
              .sort((a, b) => a.minimalSum > b.minimalSum ? -1 : 1)
              .map((rebateClause, i) => (!this.state.activeRebate && i == 0 && (<div style={{ marginBottom: "0.5rem" }} key={i} className="notification has-background-success-bleached-super">
                <p>При внесении предоплаты за оригинальные запасные части {rebateClause.brandNames} Ваша скидка увеличится до {rebateClause.cartDiscount}%.</p>
                <p className="is-size-7">Предложение не распространяется на детали под заказ.</p>
                <br></br>
                <div className="control">
                  <button className="button" onClick={(event) => this.handleRebate(rebateClause)}>
                    <span>Получить скидку</span>
                  </button>
                </div>
              </div> )))
          )}
          {this.state.activeRebate && (
            <div>
              <p className="is-size-5 has-text-danger-dark">Обратите внимание! Для получения заказа требуется предварительная оплата за оригинальные запасные части {this.state.activeRebate.brandNames}.</p>
              <p className="is-size-7 has-text-danger-dark">Предложение не распространяется на детали под заказ.</p>
              <br/>
            </div>
          )}
        </React.Fragment>
        {!this.state.isLoading && recommendedCartItems.length > 0 && table}
        <React.Fragment>
          <br></br>
          <a className="button" href="https://turbotrucks.ru/cart">
            <Icon icon="shopping-cart" />{' '}
            <span>Вернуться в мою корзину</span>
          </a>
        </React.Fragment>
      </React.Fragment>
    );
  }
}

RecommendedCart.propTypes = {
  branches: PropTypes.arrayOf(PropTypes.object),
  recomendedCartItem: PropTypes.arrayOf(PropTypes.object),
  discardedRecomendedCartItemCartItems: PropTypes.arrayOf(PropTypes.object),
  deliveryWays: PropTypes.arrayOf(PropTypes.object),
  rebateClauses: PropTypes.arrayOf(PropTypes.object),
  paymentTypes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  deliveryPreferences: PropTypes.arrayOf(PropTypes.object),
  selectedBranch: PropTypes.number,
  selectedDeliveryWay: PropTypes.number,
  sorting: PropTypes.string,
  employee: PropTypes.bool,
  canBuyForClient: PropTypes.bool,
  companies: PropTypes.arrayOf(PropTypes.object),
  canPayOnline: PropTypes.bool,
  onChangeSelected: PropTypes.func,
  allSelected: PropTypes.bool,
  needConfirm: PropTypes.bool,
  needCompensation: PropTypes.bool
};

export default RecommendedCart;
